/* ==========================================================================
   HOME PASSION - ACILIR SEPET  (ad alani: hpx-)

   ==========================================================================
   CIFT INDIRIM HATASI - IKINCI VE KESIN DUZELTME
   ==========================================================================
   ILK SURUM soyle hesapliyordu:

       var sub  = cart.total_price;
       var save = Math.round(sub * off/100);
       var pay  = sub - save;

   IKINCI SURUM bunu "cart_level_discount_applications bos mu" diye
   kontrol ederek duzeltmeye calisti. Ama bu magazadaki set indirimleri
   indirimi SATIR duzeyinde tahsis ediyor; cart_level listesi HEP
   BOS geliyor. Yani kontrol hicbir zaman tutmuyor ve cekmece yine
   ikinci kez indirim uyguluyordu.

   DOGRU MANTIK - tek olcut, katmandan bagimsiz:
     temel      = original_total_price            (HICBIR indirim yokken)
     uygulanmis = original_total_price - total_price
                  (satir + sepet duzeyi, hepsi dahil)

   ==========================================================================
   KARSILIGI OLMAYAN INDIRIM TAHMINI KALDIRILDI
   ==========================================================================
   Cekmece bir donem sepette hicbir indirim yokken adet esigine bakip
   yuzdeyi KENDISI uyguluyor ve "indirim odemede uygulanir" diyordu.
   Set indirimleri yalnizca "Tum Dekoratif Yastiklar" koleksiyonunu
   kapsiyor; 4 puf koyan musteriye %20 tasarruf gosterilip odemede hicbir
   sey inmiyordu. Artik yalnizca GERCEKTEN uygulanmis indirim gosterilir.

   ==========================================================================
   OLU INDIRIM KODU YONLENDIRMESI KALDIRILDI
   ==========================================================================
   "Odemeye Gec" butonu bazi durumlarda /discount/SET15?redirect=/checkout
   adresine gidiyordu. Magazada SET10 / SET15 / SET20 diye bir kod YOK;
   bu yonlendirme sepete calismayan bir kod yapistiriyordu. Indirimler
   otomatik oldugu icin dogrudan /checkout adresine gidiliyor.

   ==========================================================================
   HEDIYE PAKETI VAADI KALDIRILDI
   ==========================================================================
   Cekmece "15.000 TL'yi gec, hediye paketi de senin" diyordu. Magazada
   boyle bir kural, boyle bir urun ya da boyle bir otomatik indirim YOK —
   tamamen uydurma bir vaatti. Kilometre tasi seridinden ve mesajlardan
   tamamen cikarildi; geriye yalnizca gercek olan UCRETSIZ KARGO esigi
   kaldi (Ayarlar > Kargo ile ayni: 10.000 TL).

   ==========================================================================
   KARGO SATIRI
   ==========================================================================
   Cekmece "Odenecek" satiri kargoyu HIC gostermiyordu. Musteri 400,00 TL
   kargo bedelini ilk kez odeme adiminda goruyordu. Artik kargo ayri bir
   satir olarak gosteriliyor ve odenecek tutara dahil ediliyor.

   ==========================================================================
   422 YANITI
   ==========================================================================
   Cekmece icindeki "Sepetini tamamla" ekle butonu r.ok'i kontrol
   etmiyordu; stok yetmediginde hicbir sey eklenmedigi halde sepet
   tazeleniyor ve hata gorunmuyordu. Artik Shopify'in mesaji gosteriliyor.
   ========================================================================== */
(function(){
  'use strict';

  var cfg    = window.HP_DC || {};
  var freeAt = (parseInt(cfg.free,10)||0) * 100;
  var shipAt = (parseInt(cfg.shipCost,10)||0) * 100;
  var freeLb = cfg.freeLabel || 'Ücretsiz kargo';
  var taksit = parseInt(cfg.taksit,10) || 0;
  var tiers  = (cfg.tiers||[]).filter(function(t){ return t.q>0; })
                              .sort(function(a,b){ return a.q-b.q; });
  var cross  = cfg.cross || [];

  var scrim, box, body, foot, head, built=false;

  function money(c){
    return new Intl.NumberFormat('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2}).format(c/100)+' TL';
  }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(m){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]; }); }

  function shortTitle(raw){
    var parts = String(raw||'').split('|');
    var s = (parts[0]||'').trim();
    if(s.length < 14 && parts.length > 1){ s = (parts[1]||'').trim(); }
    s = s.replace(/Dekoratif Yastık Kılıfı|Dekoratif Bel Kırlenti|Dekoratif Kırlent|Yastık Kılıfı|Bel Kırlenti|\(Kırlent\)|Kırlent/g,'');
    s = s.replace(/\s+-\s+/g,' · ').replace(/-\s+/g,' · ').replace(/\s+-/g,' · ');
    s = s.replace(/\s{2,}/g,' ').replace(/·\s*·/g,'·').trim();
    s = s.replace(/^[·-]\s*/,'').replace(/\s*[·-]$/,'').trim();
    return s.length > 42 ? s.slice(0,42).trim()+'…' : s;
  }

  function tierFor(n){
    var cur=null, next=null;
    tiers.forEach(function(t){ if(n>=t.q) cur=t; });
    for(var i=0;i<tiers.length;i++){ if(n<tiers[i].q){ next=tiers[i]; break; } }
    return {cur:cur, next:next};
  }

  /* Sepette GERCEKTEN uygulanmis TUM indirimler - satir duzeyi de dahil. */
  function allDiscount(cart){
    var d = (cart.original_total_price||0) - (cart.total_price||0);
    return d > 0 ? d : 0;
  }

  var TICK='<svg viewBox="0 0 24 24"><path d="M5 12l5 5L19 7"/></svg>';

  function build(){
    if(built) return; built=true;
    scrim=document.createElement('div'); scrim.className='hpx-scrim';
    box=document.createElement('aside'); box.className='hpx-cart'; box.setAttribute('aria-label','Sepet');
    box.innerHTML=
      '<div class="hpx-h"><h2>Sepetin <span data-n></span></h2>'+
      '<button class="hpx-x" type="button" aria-label="Kapat"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>'+
      '<div data-ms></div>'+
      '<div class="hpx-b" data-body></div>'+
      '<div class="hpx-f" data-foot></div>';
    document.body.appendChild(scrim);
    document.body.appendChild(box);
    body=box.querySelector('[data-body]');
    foot=box.querySelector('[data-foot]');
    head=box.querySelector('[data-ms]');

    scrim.addEventListener('click', close);
    box.querySelector('.hpx-x').addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });

    box.addEventListener('change', function(e){
      var sel=e.target.closest('select[data-qsel]');
      if(sel){ change(sel.dataset.qsel, parseInt(sel.value,10)); }
    });

    box.addEventListener('click', function(e){
      var rm=e.target.closest('[data-rm]');
      if(rm){
        var line=rm.closest('.hpx-line'); if(line) line.classList.add('going');
        return change(rm.dataset.rm, 0);
      }
      var add=e.target.closest('[data-dcadd]');
      if(add){
        var old=add.textContent;
        add.disabled=true; add.textContent='…';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:parseInt(add.dataset.dcadd,10),quantity:1}]})})
          .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, data:j}; }); })
          .then(function(res){
            if(!res.ok){
              /* 422 — eklenmedi. Shopify'in kendi mesajini goster. */
              add.disabled=false; add.textContent=old;
              var w=add.parentNode.querySelector('.hpx-cr-err');
              if(!w){ w=document.createElement('div'); w.className='hpx-cr-err';
                w.style.cssText='flex-basis:100%;margin:4px 0 0;font-size:.75rem;line-height:1.4;color:#B3261E';
                add.parentNode.appendChild(w); }
              w.textContent=(res.data && (res.data.description||res.data.message)) || 'Bu ürün şu an eklenemedi.';
              return;
            }
            load();
          })
          .catch(function(){ add.disabled=false; add.textContent=old; });
      }
    });
  }

  function change(key,q){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,quantity:q})})
      .then(function(r){return r.json()}).then(render)
      .catch(function(){ load(); });
  }

  /* Kilometre tasi seridi — YALNIZCA gercek kural: ucretsiz kargo esigi.
     Uydurma "hediye paketi" esigi kaldirildi. */
  function milestones(total){
    if(!freeAt) return '';
    var h='<div class="hpx-ms"><div class="hpx-ms-row">'+
          '<div class="hpx-ms-i'+(total>=freeAt?' on':'')+'">'+
          '<span class="hpx-ms-dot">'+TICK+'</span>'+
          '<span class="hpx-ms-l">'+esc(freeLb)+'</span></div>'+
          '</div><div class="hpx-ms-track"><i style="width:'+Math.min(100,(total/freeAt)*100)+'%"></i></div>';
    var msg = (total < freeAt)
      ? '<b>'+money(freeAt-total)+'</b> daha ekle, kargo bizden.'
      : '<em>Kargo bedava!</em> Siparişin ücretsiz kargoya uygun.';
    h+='<div class="hpx-ms-msg">'+msg+'</div></div>';
    return h;
  }

  function render(cart){
    /* /cart/change.js hata dondugunde govdede items YOKTUR; dogrudan
       islersek tutarlar NaN olur. Boyle bir durumda sepeti tazeden cek. */
    if(!cart || !cart.items){ load(); return; }

    box.querySelector('[data-n]').textContent = cart.item_count ? '('+cart.item_count+')' : '';
    document.querySelectorAll('.cart-count-bubble span:first-child,[data-cart-count]')
      .forEach(function(el){ el.textContent=cart.item_count; });

    if(!cart.item_count){
      head.innerHTML='';
      body.innerHTML='<div class="hpx-empty"><p>Sepetin henüz boş.</p>'+
        '<a href="'+(cfg.shopUrl||'/collections/all')+'">Alışverişe Başla</a></div>';
      foot.innerHTML=''; return;
    }

    /* ---------- TUTARLAR - tek dogru kaynak ---------- */
    var base    = (cart.original_total_price != null)
                    ? cart.original_total_price
                    : cart.total_price;
    var save    = allDiscount(cart);
    var pay     = cart.total_price;
    var t       = tierFor(cart.item_count);

    var ship  = (freeAt>0 && pay>=freeAt) ? 0 : shipAt;
    var grand = pay + ship;

    head.innerHTML = milestones(pay);

    var h='';

    /* Kademe mesaji.
       - Indirim UYGULANMISSA bir sonraki kademeye itmek dogru.
       - Hic indirim yoksa "X parca daha ekle" demek yaniltici olabilir:
         sepettekiler kapsam disi (puf, berjer) olabilir. Bu durumda kuralin
         kendisi soylenir, sepete ozel bir vaat verilmez. */
    var tmsg='';
    if(save>0){
      tmsg = t.next
        ? '<b>'+(t.next.q-cart.item_count)+' parça</b> daha ekle, <em>%'+t.next.p+' set indirimi</em> başlasın.'
        : '<em>En yüksek set kademesindesin</em> — indirim sepete uygulandı.';
    } else if(tiers.length){
      tmsg = '<b>Dekoratif yastıklarda</b> '+tiers.map(function(x){ return x.q+' parça %'+x.p; }).join(' · ')+' set indirimi otomatik uygulanır.';
    }
    if(tmsg){
      h+='<div class="hpx-tier"><svg viewBox="0 0 24 24"><path d="M3 8l9-4 9 4v8l-9 4-9-4z"/><path d="M3 8l9 4 9-4M12 12v8"/></svg><span>'+tmsg+'</span></div>';
    }

    cart.items.forEach(function(it){
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i,'_280x$1$2') : '';
      var opts='';
      if(it.options_with_values && it.options_with_values.length){
        opts = it.options_with_values.filter(function(o){ return o.value && String(o.value).toLowerCase()!=='default title'; })
          .map(function(o){ return esc(String(o.value).replace(/\*/g,'×')); }).join(' · ');
      } else if(it.variant_title){
        opts = esc(it.variant_title.replace(/\*/g,'×'));
      }

      var sel='<select data-qsel="'+esc(it.key)+'" aria-label="Adet">';
      for(var q=1;q<=10;q++){ sel+='<option value="'+q+'"'+(q===it.quantity?' selected':'')+'>'+q+'</option>'; }
      sel+='</select>';

      var fiyat = (it.original_line_price>it.final_line_price)
        ? '<del>'+money(it.original_line_price)+'</del>'+money(it.final_line_price)
        : money(it.final_line_price);

      h+='<div class="hpx-line">'+
         '<a class="hpx-img" href="'+esc(it.url)+'">'+(img?'<img src="'+esc(img)+'" alt="">':'')+'</a>'+
         '<div>'+
           '<a class="hpx-t" href="'+esc(it.url)+'">'+esc(shortTitle(it.product_title))+'</a>'+
           (opts?'<div class="hpx-o">'+opts+'</div>':'')+
           '<div class="hpx-pr">'+fiyat+'</div>'+
           '<div class="hpx-bot">'+
             '<button class="hpx-rm" type="button" data-rm="'+esc(it.key)+'">Kaldır</button>'+
             '<span class="hpx-qw"><span>Adet</span>'+sel+'</span>'+
           '</div>'+
         '</div></div>';
    });

    var inCart = cart.items.map(function(i){ return i.product_id; });
    var sug = cross.filter(function(c){ return inCart.indexOf(c.pid)===-1; }).slice(0,3);
    if(sug.length){
      h+='<div class="hpx-cross"><div class="hpx-cross-h">Sepetini tamamla</div>';
      sug.forEach(function(c){
        h+='<div class="hpx-cr">'+
           '<a class="hpx-cr-i" href="'+esc(c.url)+'">'+(c.img?'<img src="'+esc(c.img)+'" alt="">':'')+'</a>'+
           '<div><a class="hpx-cr-t" href="'+esc(c.url)+'">'+esc(shortTitle(c.title))+'</a>'+
           '<span class="hpx-cr-p">'+money(c.price)+'</span></div>'+
           '<button class="hpx-cr-b" type="button" data-dcadd="'+c.vid+'">Ekle</button></div>';
      });
      h+='</div>';
    }

    body.innerHTML=h;

    /* ---------- Alt blok ---------- */
    var mini = 'Ara toplam '+money(base);
    if(save>0){
      mini += ' <i>·</i> <em>set indirimi −'+money(save)+'</em>';
    }

    var f='<div class="hpx-mini"><span>'+mini+'</span></div>'+
          '<div class="hpx-r"><span>Kargo</span><b>'+(ship===0?'Ücretsiz':money(ship))+'</b></div>';

    if(ship>0 && freeAt>0){
      f+='<div class="hpx-mini"><span>'+money(freeAt-pay)+' daha ekleyin, kargo bedava.</span></div>';
    }

    f+='<div class="hpx-r grand"><span>Ödenecek</span><b>'+money(grand)+'</b></div>';

    if(taksit>0){
      f+='<div class="hpx-tak"><svg viewBox="0 0 24 24"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>'+
         '<span>veya <b>'+taksit+' taksit × '+money(Math.round(grand/taksit))+'</b> · faizsiz</span></div>';
    }

    f+='<button class="hpx-go" type="button" data-go>Ödemeye Geç<span class="amt">'+money(grand)+'</span></button>'+
       '<div class="hpx-foot-l">'+
         (save>0 ? 'İndirim sepete uygulandı' : 'İndirim kodun varsa sonraki adımda girebilirsin')+
         ' <i>·</i> <a href="/cart">Sepeti görüntüle</a></div>';

    foot.innerHTML=f;

    foot.querySelector('[data-go]').addEventListener('click',function(){
      /* Set indirimleri otomatik — kod yonlendirmesi yok, dogrudan odemeye. */
      location.href='/checkout';
    });
  }

  function load(){ fetch('/cart.js').then(function(r){return r.json()}).then(render); }

  function open(){
    build(); load();
    setTimeout(function(){
      scrim.classList.add('on'); box.classList.add('on');
      document.documentElement.style.overflow='hidden';
    }, 20);
  }
  function close(){
    if(!box) return;
    scrim.classList.remove('on'); box.classList.remove('on');
    document.documentElement.style.overflow='';
  }

  window.hpCartOpen = open;

  document.addEventListener('click', function(e){
    var a=e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
    if(a && !e.metaKey && !e.ctrlKey && !a.closest('.hpx-foot-l')){ e.preventDefault(); open(); }
  });
  document.addEventListener('hp:cart-added', function(){ open(); });
})();
